<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    :width="cardWidth"
    id="export-confirmation"
  >
    <v-card style="overflow-x: hidden" class="pa-4">
      <div class="d-flex flex-column">
        <h2>Reconciliation</h2>
        <div style="width:100%; border-top: solid 1px black;" class="pa-3">
          <h3>Your return report has been exported.</h3>
          <h3>Send this report to the following email addresses:</h3>
          <v-form v-model="isFormValid" class="pt-5">
            <v-row v-for="(email, i) in emails" :key="i" class="pr-10 pl-10">
              <v-text-field
                v-model="reportEmails[i]"
                label="Email"
                filled
                required
                :rules="emailRules"
                clearable
                append-outer-icon="mdi-close"
                @click:append-outer="removeEmail(i)"
              ></v-text-field>
            </v-row>
          </v-form>
          <div class="d-flex justify-end">
            <v-card
              class="mr-4 mt-0 d-flex align-center"
              height="40"
              width="40"
              color="secondary"
              @click="emailAnother()"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-plus</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
        </div>
        <div class="d-flex justify-center align-center flex-column">
          <v-btn
            class="white--text mb-3 mt-3"
            color="secondary"
            @click="exportReport()"
            :width="180"
          >
            <v-icon small>mdi-send</v-icon>
            Send
          </v-btn>
          <v-btn class="mb-3" @click="_setActive(false)" :width="180">
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  mixins: [MobileView],
  data: () => ({
    emails: 1,
    reportEmails: [],
    isFormValid: false,
    emailRules: [(v) => /.+@.+/.test(v) || 'Invalid Email address'],
  }),
  methods: {
    ...mapMutations({
      _setActive: 'reconciliation/setExportConfirmation',
      setExportData: 'reconciliation/setExportData',
    }),
    exportReport() {
      const exportObject = this.getExportData;
      exportObject.emails = this.reportEmails;
      this.setExportData(exportObject);
      this._setActive(false);
    },
    emailAnother() {
      this.emails++;
    },
    removeEmail(index) {
      this.reportEmails.splice(index, 1);
      this.emails -= 1;
    },
  },
  computed: {
    ...mapGetters({
      _active: 'reconciliation/getExportConfirmation',
      getExportData: 'reconciliation/getExportData',
    }),
    cardWidth() {
      if (this.showMobileView) {
        return '';
      }
      return '50%';
    },
  },
};
</script>

<style></style>
